import ChatPersona from './ChatPersona';
import { setChatState } from '../actions/ucmaActions';
import { setIsChatCalloutShown } from '../actions/ucmaActions';
import { getUnreadMessageCountForOneChat } from '../chatManager/chatFilters';
import { startChatWithName } from '../chatManager/startChat';
import StartChatSource from '../store/schema/StartChatSource';
import getPresenceFromStore from '../presenceManager/getPresenceFromStore';
import getSipUri from '../presenceManager/getSipUri';
import tryRegisterForPresenceUpdates from '../presenceManager/tryRegisterForPresenceUpdates';
import ChatState from '../store/schema/ChatState';
import ChatViewState from '../store/schema/ChatViewState';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import * as React from 'react';

const styles = require('./ChatContact.scss');

export interface ChatContactPersona {
    EmailAddress: EmailAddressWrapper;
    ImAddress: string;
    linkedChatViewState?: ChatViewState;
}

export interface ChatContactProps {
    contactInfo: ChatContactPersona;
}

export default observer(function ChatContact(props: ChatContactProps) {
    const { EmailAddress, ImAddress, linkedChatViewState } = props.contactInfo;
    const unreadCount = linkedChatViewState
        ? getUnreadMessageCountForOneChat(linkedChatViewState)
        : 0;
    const sipUri = getSipUri(ImAddress ? ImAddress : EmailAddress.EmailAddress);

    const onClick = React.useCallback(() => {
        if (linkedChatViewState) {
            setChatState(linkedChatViewState, ChatState.Normal);
        } else {
            startChatWithName(
                [
                    {
                        sipUri: sipUri,
                        name: EmailAddress.Name,
                    },
                ],
                undefined,
                StartChatSource.Dispatcher
            );
        }
        setIsChatCalloutShown(false);
    }, [sipUri, EmailAddress.Name, linkedChatViewState]);

    React.useEffect(() => {
        tryRegisterForPresenceUpdates(EmailAddress.EmailAddress);
    }, [EmailAddress.EmailAddress]);

    const presenceInfo = getPresenceFromStore(EmailAddress.EmailAddress);

    return (
        <button onClick={onClick} className={styles.chatContact}>
            {linkedChatViewState ? (
                <ChatPersona
                    linkedChatViewState={linkedChatViewState}
                    primaryTextClassName={unreadCount > 0 ? styles.unreadBold : undefined}
                />
            ) : (
                <PersonaControl
                    name={EmailAddress.Name}
                    className={styles.persona}
                    emailAddress={EmailAddress.EmailAddress}
                    size={PersonaSize.size24}
                    showPersonaDetails={true}
                    showPresence={true}
                    presence={presenceInfo}
                    styleProps={{
                        primaryText: unreadCount > 0 ? styles.unread : undefined,
                    }}
                />
            )}
            {unreadCount > 0 && <div className={styles.unreadCount}>{unreadCount}</div>}
        </button>
    );
});
